<template>
  <div class="stage-many-type">
    <!--规格属性-->
    <div class="stage-wrap">
      <div v-for="(attr, index) in form.model.sku.stageMany" :key="attr.stageName" class="mb16 min-spc">
        <div class="stage-hd">
          <div class="input-box">{{ attr.stageName }}</div>
          <a href="javascript:void(0);" @click="onDeleteGroup(index)"><i class="el-icon-delete"></i></a>
        </div>
        <div>
          <el-table :key="randomKey" :data="attr.stageItems" border size="mini"
                    style="width: 100%; margin-top: 5px">
            <el-table-column label="序号"
                             property="index">
            </el-table-column>
            <el-table-column label="重量"
                             property="stageWeight">
              <template slot-scope="scope">
                <el-input v-if="scope.row[scope.column.property + 'isShow']" :ref="scope.column.property"
                          v-model="scope.row.stageWeight"
                          class="tb-input"
                          type="number"></el-input>
                <span v-else>{{ scope.row.stageWeight }}</span>
              </template>
            </el-table-column>
            <el-table-column label="价格"
                             property="stageValue">
              <template slot-scope="scope">
                <el-input v-if="scope.row[scope.column.property + 'isShow']" :ref="scope.column.property"
                          v-model="scope.row.stageValue"
                          class="tb-input"
                          type="number"></el-input>
                <span v-else>{{ scope.row.stageValue }}</span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.editing" size="small" type="text" @click="editClick(index,scope)">编辑
                </el-button>
                <div v-else class="op-confirm">
                  <el-button size="small" style="color: #67c23a" type="text" @click="confirmClick(index,scope)">确定
                  </el-button>
                  <el-button size="small" style="color: #F56C6C" type="text" @click="cancelClick(index,scope)">取消
                  </el-button>
                </div>
                <el-button size="small" type="text" @click="deleteClick(index,scope)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="stage-hd">
            <el-button :loading="attr.loading" class="el-icon-circle-plus" size="small"
                       @click="onAddRowValue(index,scope)">
              添加一行
            </el-button>
          </div>
        </div>
      </div>
      <!--添加规则-->
      <div v-if="!form.isSpecLocked">
        <el-button v-show="showAddGroupBtn" class="el-icon-circle-plus" size="small" @click="onToggleAddGroupForm">
          添加规则
        </el-button>
      </div>
      <!--规格列表-->
      <div v-show="!showAddGroupBtn" class="add-stage mb16">
        <div class="from-box">
          <div class="item">
            <span class="key">政策名：</span>
            <el-input v-model="addGroupFrom.stageName" placeholder="请输入规格名称" size="small"></el-input>
          </div>
          <div class="item">
            <span class="key">默认：</span>
            <el-checkbox v-model="addGroupFrom.master" @change="handleCheckedMasterChange">是</el-checkbox>
          </div>
          <el-button :loading="groupLoading" plain size="small" type="primary" @click="onSubmitAddGroup">确定
          </el-button>
          <el-button size="small" @click="onToggleAddGroupForm">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Sortable from 'sortablejs' //引入插件
import {sortBy} from 'lodash-es';

export default {
  data() {
    return {
      /*显示添加规格组按钮*/
      showAddGroupBtn: true,
      /*显示添加规格组表单*/
      showAddGroupForm: false,
      /*新增规格组值*/
      addGroupFrom: {
        stageName: '',
        master: false
      },
      groupLoading: false,
      randomKey: Math.random(),
    }
  },
  inject: ['form'],
  created() {
  },
  mounted() {
    // 阻止默认行为
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.$once("hook: updated", function () {
      // this.rowDrop()//行拖拽
    })
  },
  updated() {
    this.rowDrop()//行拖拽
  },
  methods: {
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      if (tbody == null) {
        return
      }
      Sortable.create(tbody, {
        onEnd({newIndex, oldIndex}) {
          if (newIndex == oldIndex) return
          _this.tableData.splice(
            newIndex,
            0,
            _this.tableData.splice(oldIndex, 1)[0]
          )
          var newArray = _this.tableData.slice(0)
          _this.tableData = []
          _this.$nextTick(function () {
            _this.tableData = newArray
          })
        }
      })
    },
    /*显示/隐藏添加规则组 */
    onToggleAddGroupForm: function () {
      this.showAddGroupBtn = !this.showAddGroupBtn;
      this.showAddGroupForm = !this.showAddGroupForm;
    },

    /*表单提交：新增规格组 */
    onSubmitAddGroup: function () {
      let self = this;
      if (self.addGroupFrom.stageName === '') {
        self.$message('请填写规则名');
        return false;
      }
      // 添加到数据库
      self.groupLoading = true;
      let Params = {
        stageName: self.addGroupFrom.stageName,
        master: self.addGroupFrom.master,
        productSkuId: self.form.model.sku.productSkuId
      };
      PorductApi.addStage(Params, true)
        .then(res => {
          self.groupLoading = false;
          // 记录规格数据
          self.form.model.sku.stageMany.push({
            id: res.data['stageId'],
            stageName: self.addGroupFrom.stageName,
            stageItems: [
              {
                id: 0,
                stageId: res.data['stageId'],
                stageWeight: 0,
                stageValue: 0,
                index: self.form.model.sku.stageMany.length + 1,
              }
            ],
            tempValue: '',
            loading: false
          });
          // 清空输入内容
          self.addGroupFrom.stageName = '';
          self.addGroupFrom.master = false;
          // 隐藏添加规则组
          self.onToggleAddGroupForm();
          // 构建规格组合列表
        })
        .catch(error => {
          self.groupLoading = false;
        });
    },
    /*新增规格值*/
    onAddRowValue: function (index, scope) {
      let self = this;
      let items = self.form.model.sku.stageMany[index].stageItems;
      let stageId = 0;
      let mIndex = 0;
      if (items.length > 0) {
        stageId = items[0].stageId
        mIndex = self.form.model.sku.stageMany[index].stageItems.length
      } else {
        stageId = self.form.model.sku.stageMany[index].id
      }
      self.form.model.sku.stageMany[index].stageItems.push({
        id: 0,
        stageId: stageId,
        stageWeight: 0,
        stageValue: 0,
        index: mIndex,
      });
    },
    /*删除规格组事件*/
    onDeleteGroup: function (index) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          // 删除指定规则组
          PorductApi.delStage(
            {
              id: self.form.model.sku.stageMany[index].id
            },
            true
          )
            .then(data => {
              if (data.code == 200) {
                self.$message({
                  message: '恭喜你，删除成功',
                  type: 'success'
                });
                self.form.model.sku.stageMany.splice(index, 1);
                self.refreshTable()
              }
            })
            .catch(error => {
              scope.row.loading = false;
            });

          self.refreshTable()
        });
    },
    //监听复选框选中
    handleCheckedMasterChange(e) {
      let self = this;
      self.form.master = e;
    },
    /*打开编辑*/
    editClick(index, scope) {
      let self = this;
      Object.keys(scope.row).forEach(function (item, index) {
        scope.row[item + "isShow"] = true
      })

      scope.row["editing"] = true
      //refreshTable是table数据改动时，刷新table的
      this.refreshTable()
    }, /*打开编辑*/
    confirmClick(index, scope) {
      let self = this;
      // 添加到数据库
      scope.row.loading = true;
      console.log(scope)
      let Params = {
        id: scope.row.id,
        stageId: scope.row.stageId,
        stageWeight: scope.row.stageWeight,
        stageValue: scope.row.stageValue
      };
      PorductApi.addStageValue(Params, true)
        .then(res => {
          Object.keys(scope.row).forEach(function (item, index) {
            scope.row[item + "isShow"] = false
          })
          scope.row.id = res.data['stageValueId'],
            scope.row["editing"] = false
          self.checkRowIndex(self.form.model.sku.stageMany[index].stageItems);
          this.refreshTable()
        })
        .catch(error => {
          scope.row.loading = false;
        });
    }, /*打开编辑*/
    cancelClick(index, scope) {
      let self = this;
      Object.keys(scope.row).forEach(function (item, index) {
        scope.row[item + "isShow"] = false
      })
      scope.row["editing"] = false
      //refreshTable是table数据改动时，刷新table的
      this.refreshTable()
    },
    refreshTable() {
      this.randomKey = Math.random()
    },
    checkRowIndex(stageItems) {
      let self = this;
      console.log(stageItems)
      sortBy(stageItems, function (item) {
        return -item.stageWeight;
      });
      console.log(stageItems)

      for (let len = stageItems.length, i = 0; i < len; i++) {
        stageItems[i].index = i + 1;
      }

    },
    /*刷新心也*/
    refresh() {
      this.reload();
      // 直接使用reload方法
    },

    /*删除*/
    deleteClick(index, scope) {
      let self = this;

      if (self.form.isSpecLocked) {
        self.$message({
          message: '本设备正在搞活动，不能删除规格！',
          type: 'warning'
        });
        return;
      }

      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          if (scope.row.id === 0) {
            self.form.model.sku.stageMany[index].stageItems.splice(index, 1);
            self.checkRowIndex(self.form.model.sku.stageMany[index].stageItems);
            self.refreshTable()
          } else {
            scope.row.loading = true;
            PorductApi.delStageValue(
              {
                id: scope.row.id
              },
              true
            )
              .then(data => {
                scope.row.loading = false;
                if (data.code == 200) {
                  self.$message({
                    message: '恭喜你，该行删除成功',
                    type: 'success'
                  });
                  self.form.model.sku.stageMany[index].stageItems.splice(index, 1);
                  self.checkRowIndex(self.form.model.sku.stageMany[index].stageItems);
                  self.refreshTable()
                }
              })
              .catch(error => {
                scope.row.loading = false;
              });
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style scoped="scoped">
.stage-many-type {
  margin-left: 180px;
  margin-top: 16px;
  padding: 20px;
  border: 1px solid #e5ecf4;
  background: #f6f9fc;
}

.stage-wrap .stage-hd {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  font-weight: bold;
}

.stage-wrap .stage-hd .el-icon-delete-solid {
  font-size: 16px;
  color: #999999;
}

.stage-wrap .min-spc {
  border: 1px solid #dfecf8;
}

.stage-wrap .stage-bd {
  padding: 5px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  border-top: 1px solid #dfecf8;
  background: #ffffff;
}

.stage-wrap .stage-bd .el-tag {
  color: #333333;
}

.stage-wrap .stage-bd .item {
  position: relative;
  padding: 5px;
}

.stage-wrap .stage-bd .item input {
  padding-right: 30px;
}

.stage-wrap .stage-hd a,
.stage-wrap .stage-hd .svg-icon,
.stage-wrap .stage-bd .item .svg-icon {
  display: block;
  width: 16px;
  height: 16px;
}

.stage-wrap .stage-bd .item a {
  position: absolute;
  top: 6px;
  right: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.add-stage .from-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.op-confirm {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  -webkit-transition: .1s;
  transition: .1s;
  margin-right: 10px
}

.add-stage .item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 200px;
  margin-right: 20px;
}

.add-stage .item .key {
  display: block;
  white-space: nowrap;
}

.tb-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/priceStage/many/Type.vue